module.exports = __webpack_public_path__ + "img/1F626.9ef55cb2.svg";